module.exports = __webpack_public_path__ + "media/images/icons/organization-b84740479cf7724c372f81425a4859c4.svg";